import * as Yup from "yup";

export const CustomerSchema = Yup.object({
    name: Yup.string().required(" Enter  Name").matches(/^[a-zA-Z0-9!@#$%&()-`.+,/\"]/, "Empty Space Not Allow"),   
    email:Yup.string().required(" Enter Email"),
    password:Yup.string().required(" Enter  Password"),
    year:Yup.string().required(" Select Year"),
    branch:Yup.string().required(" Select Branch"),
    type:Yup.string().required(" Select Type"),
    hod:Yup.string().required(" Select HOD"),
    // status: Yup.string().required(" Select Status"),
    
});
export const UpdateCustomerSchema = Yup.object({
    name: Yup.string().required(" Enter  Name").matches(/^[a-zA-Z0-9!@#$%&()-`.+,/\"]/, "Empty Space Not Allow"),   
    email:Yup.string().required(" Enter Email"),
    // password:Yup.string().required(" Enter  Password"),
    year:Yup.string().required(" Select Year"),
    branch:Yup.string().required(" Select Branch"),
    status: Yup.string().required(" Select Status"),
    type:Yup.string().required(" Select Type"),
    hod:Yup.string().required(" Select HOD"),
    
});